import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Typography,
  Card, CardHeader,
  Avatar,
  Button, FormControl, Select, InputLabel, MenuItem
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import Page from '../../components/Page';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import qs from 'qs'
import request from '../../components/request'
import { UpLoadInput } from '../MyComponents';
import { useOutletContext, useNavigate, useParams } from 'react-router-dom';

const CSelect = (props) => {
  let { labelId, label, source } = props;

  let [data, setData] = useState([]);
  const loadData = async () => {
    var result = await request.GetData(source, {})
    if (result.Code === 1) {
      setData(result.Result);
    }
    else {

    }
  }

  useEffect(() => {
    loadData();
  }, [source])

  return (
    <FormControl sx={{ minWidth: 200 }}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        {...props}
      >
        {data.map((item) => <MenuItem value={`${item.id}`}>{item.Name}</MenuItem>)}
      </Select>
    </FormControl>
  )
}

export default function CreateShangHu() {
  const navigete = useNavigate();
  const [setTools] = useOutletContext();
  let { id } = useParams();

  const loadData = async () => {
    var result = await request.GetData('Web/Admin/Set/GetShanghu?id=' + id, {})
    if (result.Code === 1) {
      formik.setValues(result.Result);
    }
    else {
      global.addMessage(result.Message);
    }
  }
  useEffect(() => {
    setTools([]);
    if (id) loadData();
  }, [])

  const LoginSchema = Yup.object().shape({
    Avatar: Yup.string().nullable(),
    Account: Yup.string().nullable().required('账号 必填'),
    NickName: Yup.string().nullable().required('昵称 必填'),
    Pwd: Yup.string().nullable().required('密码 必填'),
  });

  const formik = useFormik({
    initialValues: {
      Avatar: '',
      Account: '',
      NickName: '',
      Pwd: '',
    },
    validationSchema: LoginSchema,
    onSubmit: (values, actions) => {
      actions.setSubmitting(true);
      //验证
      console.log('values', JSON.stringify(values));
      submit(values).then(result => {
        //if (!result) {
        actions.setSubmitting(false);
        //}
      })
    }
  });

  const submit = async (values) => {
    let data = { ...values };
    if (!isNaN(parseInt(id))) data = { ...values, id: parseInt(id) };
    const result = await request.PostJsonData('Web/Admin/Set/CreateShanghu', data);
    if (result.Code === 1) {
      global.addMessage(result.Message);
      navigete('/dashboard/set/shanghu', { replace: true });
      return true;
    }
    else
      global.addMessage(result.Message);

    return false;
  }

  const { errors, touched, values, isSubmitting, handleChange, handleSubmit, getFieldProps } = formik;

  const Input = styled('input')({
    display: 'none',
  });

  //console.log('values', values)

  return (
    <Card>

      <Box p={3}>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>

            <Stack spacing={3} alignItems={'flex-start'}>

              <UpLoadInput title='头像' name='Avatar' formik={formik} />

              <TextField
                autoComplete="Account"
                type="text"
                label="账号"
                {...getFieldProps('Account')}
                error={Boolean(errors.Account)}
                helperText={errors.Account}
              />
              <TextField
                autoComplete="NickName"
                type="text"
                label="昵称"
                {...getFieldProps('NickName')}
                error={Boolean(errors.NickName)}
                helperText={errors.NickName}
              />
              <TextField
                autoComplete="Pwd"
                type="text"
                label="密码"
                {...getFieldProps('Pwd')}
                error={Boolean(errors.Pwd)}
                helperText={errors.Pwd}
              />

            </Stack>

            <Stack sx={{ my: 4 }}></Stack>

            <LoadingButton

              size="large"
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              保存
            </LoadingButton>

          </Form>
        </FormikProvider>
      </Box>
    </Card >
  );
}
